<template>
  <div class="catalog-component">
    <div class="area">
      <div class="row" v-animated-show="utils.handleScroll">
        <Categories
          :info="info"
          :categories="categories"
          class="col-4 col-md-12"
        ></Categories>
        <ProductsList
          :categories="categories"
          class="col-8 col-md-12"
        ></ProductsList>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import Categories from "../containers/Categories.vue";
import ProductsList from "../containers/ProductsList.vue";
export default {
  name: "Catalog",
  props: {
    info: Object,
    products: Object,
    categories: Object,
    list: Array,
  },
  data() {
    return {
      utils: utils,
      currentCategory: 0,
      currentSubcategory: 0,
    };
  },
  methods: {
    getSubcategories(id) {
      return this.categories.subcategories.list.filter(
        item => item.category === id
      );
    },
  },
  watch: {
    $route(to) {
      this.currentSubcategory = parseInt(to.query.subcat);
    },
  },
  mounted() {
    this.currentSubcategory = parseInt(this.$route.query.subcat);
  },
  components: {
    Categories,
    ProductsList,
  },
};
</script>

<style lang="scss">
.cards-component {
  @extend %page-block;
  .row-offset {
    @media all and (max-width: $md) {
      grid-gap: 26px;
    }
  }
}
</style>
